import React, { useState } from 'react';
import styled from 'styled-components';
import copyHandler from '@/utils/copy';

const Notifications: React.FC<NotificationProps> = ({ message1, message2, onClose, title }) => {
  const handleClose = () => {
    copyHandler(message1)
    window.open(message1, '_blank')
    if (onClose) onClose();
  };


  return (
    <ComponentStyle>
      <div className="notificationBox">
        <div className="notificationa">
          <div>{title}</div>
          <p onClick={() => window.open(message1, '_blank')}>{message1}</p>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ width: "90%" }}>
              {message2}
            </div>
            {/* <CopyOutlined onClick={() => copy(message2)} /> */}
            {/* <CopyButton text={message2} /> */}
          </div>
          <button onClick={handleClose} className="notification-close-btn">
          </button>
          <div className="sure" onClick={handleClose}>{("复制并打开")}</div>
        </div>
      </div>
    </ComponentStyle>
  );
};

export default Notifications;
export interface NotificationProps {
  message1: string;
  message2: string;
  message3?: string;
  onClose: () => void;
  onHandle?: () => void;
  duration?: number;
  title: string;
  redirectPath?: string;
  img?: string;
}
export const ComponentStyle = styled.div`
.notificationBox {
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  right: 0;
  width: 100vw;
  height: 100vh;
  word-wrap: break-word;
  z-index: 111;
}
.notificationa {
  position: fixed;
  top:50vh;
  transform: translateY(-50%);
  left: 25%;
  width: 50%;
  padding: 40px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border: 1px solid #909090;
  display: flex;
  color:#000;
  flex-direction: column;
  line-height: 40px;
  word-wrap: break-word;
  .notification-close-btn {
    position: absolute;
    top: 10px;
    right: 20px;
    font-size: 16px;
  }
  > div:nth-child(1) {
    border-bottom: 1px solid #666666;
    font-weight: bold;
    font-size: 22px;
    color:#000;
    text-align: center;
  }
  p {
    line-height: 40px;
  }
  .sure {
    width: 100%;
    height: 42px;
    // color: #000;
    font-weight: bold;
    text-align: center;
    background: rgb(31, 199, 212);;
    border-radius: 5px;
    cursor: pointer;
    margin-top:20px;
  }
}

.notification-close-btn {
  color: white;
  font-size: 1.2em;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.custom-textarea {
  word-break: break-all;
  outline: none;
  background-color: #1a1a1a;
  color: #fff;
  font-size: 16px;
  padding: 10px;
  border-radius: 5px;
  height: 100px;
}

.Tokenss {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
}
.tokensss {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
}
.Tokenss > div:nth-child(1) > div:nth-child(2) {
  margin-left: 10px;
}
.Tokenss > div:nth-child(1) > div:nth-child(1) {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.Tokenss:hover {
  background-color: #999;
  color: #000;
}
@media (max-width: 768px) {
  .notification {
    width: 98%;
    padding:10px;
    font-size: 14px;
    left: calc((100% - 98%) / 2);
  }
}
  `
